// extracted by mini-css-extract-plugin
export default {"checkboxWraper":"CheckboxSettings_checkboxWraper__oqncT","checkboxSettingsText":"CheckboxSettings_checkboxSettingsText__DEzCB"};